import { Component, ReactNode } from "react";
import { StyledIconGoogleMobile } from "../../styles/styles";

export default class IconGoogleMobile extends Component {
  render(): ReactNode {
    return (
      <StyledIconGoogleMobile>
        <svg
          width="73"
          height="11"
          viewBox="0 0 73 11"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.50806 7.27833H5.79606V5.66072V5.01416V3.39655H4.50806V5.01416V5.66072V7.27833Z"
            fill="#5A668A"
          />
          <ellipse
            cx="0.644001"
            cy="4.97352"
            rx="0.644001"
            ry="0.66718"
            fill="#5A668A"
          />
          <ellipse
            cx="0.644001"
            cy="5.70135"
            rx="0.644001"
            ry="0.66718"
            fill="#5A668A"
          />
          <rect y="4.97353" width="1.288" height="0.727833" fill="#5A668A" />
          <ellipse
            cx="9.66011"
            cy="5.70135"
            rx="0.644001"
            ry="0.66718"
            fill="#5A668A"
          />
          <ellipse
            cx="9.66011"
            cy="4.97352"
            rx="0.644001"
            ry="0.66718"
            fill="#5A668A"
          />
          <rect
            x="10.304"
            y="5.70135"
            width="1.288"
            height="0.727833"
            transform="rotate(180 10.304 5.70135)"
            fill="#5A668A"
          />
          <ellipse
            cx="2.86861"
            cy="7.15702"
            rx="0.644001"
            ry="0.66718"
            fill="#5A668A"
          />
          <ellipse
            cx="2.86861"
            cy="7.88485"
            rx="0.644001"
            ry="0.66718"
            fill="#5A668A"
          />
          <rect
            x="2.22461"
            y="7.15702"
            width="1.288"
            height="0.727833"
            fill="#5A668A"
          />
          <ellipse
            cx="2.86861"
            cy="2.79003"
            rx="0.644001"
            ry="0.66718"
            fill="#5A668A"
          />
          <ellipse
            cx="2.86861"
            cy="5.15548"
            rx="0.644001"
            ry="0.66718"
            fill="#5A668A"
          />
          <rect
            x="2.22461"
            y="2.79002"
            width="1.288"
            height="2.38062"
            fill="#5A668A"
          />
          <ellipse
            cx="7.43526"
            cy="3.51786"
            rx="0.644001"
            ry="0.66718"
            fill="#5A668A"
          />
          <ellipse
            cx="7.43526"
            cy="2.79003"
            rx="0.644001"
            ry="0.66718"
            fill="#5A668A"
          />
          <rect
            x="8.07935"
            y="3.51786"
            width="1.288"
            height="0.727833"
            transform="rotate(180 8.07935 3.51786)"
            fill="#5A668A"
          />
          <ellipse
            cx="5.15206"
            cy="1.39501"
            rx="0.644001"
            ry="0.66718"
            fill="#5A668A"
          />
          <ellipse
            cx="5.15206"
            cy="0.66718"
            rx="0.644001"
            ry="0.66718"
            fill="#5A668A"
          />
          <rect
            x="5.7959"
            y="1.39501"
            width="1.288"
            height="0.727833"
            transform="rotate(180 5.7959 1.39501)"
            fill="#5A668A"
          />
          <ellipse
            cx="5.15206"
            cy="10.0077"
            rx="0.644001"
            ry="0.66718"
            fill="#5A668A"
          />
          <ellipse
            cx="5.15206"
            cy="9.27987"
            rx="0.644001"
            ry="0.66718"
            fill="#5A668A"
          />
          <rect
            x="5.7959"
            y="10.0077"
            width="1.288"
            height="0.727833"
            transform="rotate(180 5.7959 10.0077)"
            fill="#5A668A"
          />
          <ellipse
            cx="7.43526"
            cy="7.88485"
            rx="0.644001"
            ry="0.66718"
            fill="#5A668A"
          />
          <ellipse
            cx="7.43526"
            cy="5.5194"
            rx="0.644001"
            ry="0.66718"
            fill="#5A668A"
          />
          <rect
            x="8.07935"
            y="7.88485"
            width="1.288"
            height="2.36546"
            transform="rotate(180 8.07935 7.88485)"
            fill="#5A668A"
          />
          <ellipse
            cx="5.15206"
            cy="3.39655"
            rx="0.644001"
            ry="0.66718"
            fill="#5A668A"
          />
          <ellipse
            cx="5.15206"
            cy="7.27833"
            rx="0.644001"
            ry="0.66718"
            fill="#5A668A"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M40.6472 7.82359H41.4349V5.38483H42.7364C43.2559 5.38483 43.7054 5.21524 44.085 4.87605C44.4646 4.53687 44.6544 4.10939 44.6544 3.5936C44.6544 3.07782 44.4646 2.65034 44.085 2.31115C43.7054 1.97197 43.2559 1.80238 42.7364 1.80238H40.6472V7.82359ZM42.7535 4.6448H41.4349V2.54242H42.7535C43.0846 2.54242 43.35 2.65174 43.5498 2.87038C43.7496 3.08903 43.8495 3.3301 43.8495 3.5936C43.8495 3.8571 43.7496 4.09817 43.5498 4.31682C43.35 4.53547 43.0846 4.6448 42.7535 4.6448ZM45.3075 4.19909C45.7128 3.77861 46.2294 3.56838 46.8573 3.56838C47.4852 3.56838 48.0018 3.77721 48.407 4.19489C48.8123 4.61256 49.015 5.13535 49.015 5.76326C49.015 6.39117 48.8123 6.91396 48.407 7.33163C48.0018 7.74931 47.4852 7.95814 46.8573 7.95814C46.2294 7.95814 45.7128 7.74931 45.3075 7.33163C44.9022 6.91396 44.6996 6.39117 44.6996 5.76326C44.6996 5.13535 44.9022 4.61396 45.3075 4.19909ZM46.8573 7.25174C46.4862 7.25174 46.1637 7.11719 45.8897 6.84809C45.6214 6.57337 45.4873 6.21177 45.4873 5.76326C45.4873 5.31475 45.6229 4.95455 45.894 4.68264C46.1652 4.41073 46.4862 4.27477 46.8573 4.27477C47.2283 4.27477 47.5494 4.41073 47.8205 4.68264C48.0917 4.95455 48.2272 5.31475 48.2272 5.76326C48.2272 6.21177 48.0917 6.57197 47.8205 6.84388C47.5494 7.11579 47.2283 7.25174 46.8573 7.25174ZM51.3891 7.95814C50.8468 7.95814 50.3788 7.74791 49.9849 7.32743C49.591 6.90695 49.3941 6.38557 49.3941 5.76326C49.3941 5.14095 49.591 4.61957 49.9849 4.19909C50.3788 3.77861 50.8468 3.56838 51.3891 3.56838C51.7088 3.56838 51.9956 3.63565 52.2496 3.77021C52.5036 3.90476 52.6934 4.07294 52.819 4.27477H52.8533L52.819 3.70293V1.80238H53.6068V7.82359H52.8533V7.25174H52.819C52.6934 7.45357 52.5036 7.62176 52.2496 7.75631C51.9956 7.89086 51.7088 7.95814 51.3891 7.95814ZM52.4637 6.84809C52.204 7.11719 51.8886 7.25174 51.5176 7.25174C51.1522 7.25174 50.8383 7.11579 50.5757 6.84388C50.3131 6.57197 50.1818 6.21177 50.1818 5.76326C50.1818 5.31475 50.3131 4.95455 50.5757 4.68264C50.8383 4.41073 51.1522 4.27477 51.5176 4.27477C51.8886 4.27477 52.204 4.40933 52.4637 4.67843C52.7234 4.94754 52.8533 5.30914 52.8533 5.76326C52.8533 6.21738 52.7234 6.57898 52.4637 6.84809ZM56.3405 7.95814C55.7126 7.95814 55.196 7.74931 54.7908 7.33163C54.3855 6.91396 54.1828 6.39117 54.1828 5.76326C54.1828 5.13535 54.3855 4.61256 54.7908 4.19489C55.196 3.77721 55.7126 3.56838 56.3405 3.56838C56.8086 3.56838 57.1968 3.6805 57.505 3.90476C57.8132 4.12901 58.0387 4.41213 58.1814 4.75412L57.4622 5.04845C57.2453 4.53266 56.8543 4.27477 56.2892 4.27477C55.941 4.27477 55.6341 4.41493 55.3687 4.69525C55.1033 4.97557 54.9706 5.33157 54.9706 5.76326C54.9706 6.19495 55.1033 6.55095 55.3687 6.83127C55.6341 7.11158 55.941 7.25174 56.2892 7.25174C56.8771 7.25174 57.2824 6.99385 57.505 6.47807L58.2071 6.7724C58.0644 7.10878 57.8346 7.3905 57.5178 7.61756C57.201 7.84462 56.8086 7.95814 56.3405 7.95814ZM58.9587 7.57971C59.2584 7.832 59.6308 7.95814 60.0761 7.95814H60.0761C60.6812 7.95814 61.1407 7.72268 61.4547 7.25174H61.4889V7.82359H62.2424V5.33437C62.2424 4.77374 62.0654 4.33925 61.7115 4.0309C61.3576 3.72255 60.9123 3.56838 60.3758 3.56838C59.9077 3.56838 59.531 3.67349 59.2455 3.88373C58.9601 4.09397 58.7689 4.32243 58.6719 4.56911L59.3911 4.87185C59.4596 4.68684 59.5866 4.54108 59.7721 4.43456C59.9576 4.32803 60.1646 4.27477 60.3929 4.27477C60.7011 4.27477 60.9609 4.36588 61.1721 4.54808C61.3833 4.73029 61.4889 4.97276 61.4889 5.27551V5.39324C61.192 5.22505 60.8125 5.14095 60.3501 5.14095C59.8306 5.14095 59.394 5.2685 59.0401 5.52359C58.6861 5.77868 58.5092 6.13047 58.5092 6.57898C58.5092 6.99385 58.659 7.32743 58.9587 7.57971ZM60.2045 7.25174C60.5299 7.25174 60.8253 7.13261 61.0907 6.89434C61.3562 6.65607 61.4889 6.37435 61.4889 6.04918C61.2662 5.86978 60.9323 5.78008 60.4871 5.78008C60.1046 5.78008 59.8164 5.86137 59.6223 6.02395C59.4282 6.18654 59.3312 6.37715 59.3312 6.5958C59.3312 6.79763 59.4196 6.95741 59.5966 7.07514C59.7736 7.19288 59.9762 7.25174 60.2045 7.25174ZM63.3878 7.62176C63.6932 7.84601 64.0799 7.95814 64.548 7.95814C65.0332 7.95814 65.4299 7.8348 65.7382 7.58812C66.0464 7.34145 66.2005 7.0331 66.2005 6.66307C66.2005 6.38836 66.1063 6.14169 65.918 5.92304C65.7296 5.70439 65.4385 5.55022 65.0446 5.46052L64.2141 5.2671C63.843 5.183 63.6575 5.02322 63.6575 4.78776C63.6575 4.62517 63.7374 4.49622 63.8973 4.40092C64.0571 4.30561 64.254 4.25795 64.4881 4.25795C64.9733 4.25795 65.2929 4.44016 65.4471 4.80458L66.132 4.52706C66.0064 4.21871 65.7981 3.98184 65.507 3.81646C65.2159 3.65107 64.8848 3.56838 64.5138 3.56838C64.0628 3.56838 63.6732 3.6819 63.345 3.90896C63.0168 4.13602 62.8527 4.43175 62.8527 4.79616C62.8527 5.11573 62.9725 5.36941 63.2123 5.55723C63.452 5.74504 63.706 5.87258 63.9743 5.93986L64.822 6.14169C65.2045 6.23699 65.3957 6.4192 65.3957 6.6883C65.3957 6.8621 65.3172 7.00226 65.1602 7.10878C65.0032 7.2153 64.802 7.26856 64.5566 7.26856C64.02 7.26856 63.6404 7.01067 63.4178 6.49489L62.7157 6.78081C62.8584 7.11719 63.0824 7.3975 63.3878 7.62176ZM68.5576 7.89086C68.118 7.89086 67.7827 7.77594 67.5515 7.54608C67.3203 7.31622 67.2047 6.99105 67.2047 6.57057V4.40933H66.4684V3.70293H67.2047V2.4415H67.9925V3.70293H69.0199V4.40933H67.9925V6.51171C67.9925 6.96022 68.1808 7.18447 68.5576 7.18447C68.7003 7.18447 68.8201 7.16204 68.9172 7.11719L69.1912 7.78154C69.0199 7.85443 68.8087 7.89086 68.5576 7.89086ZM70.1568 7.62176C70.4622 7.84601 70.849 7.95814 71.317 7.95814C71.8022 7.95814 72.1989 7.8348 72.5072 7.58812C72.8154 7.34145 72.9695 7.0331 72.9695 6.66307C72.9695 6.38836 72.8754 6.14169 72.687 5.92304C72.4986 5.70439 72.2075 5.55022 71.8136 5.46052L70.9831 5.2671C70.6121 5.183 70.4266 5.02322 70.4266 4.78776C70.4266 4.62517 70.5065 4.49622 70.6663 4.40092C70.8261 4.30561 71.0231 4.25795 71.2571 4.25795C71.7423 4.25795 72.0619 4.44016 72.2161 4.80458L72.901 4.52706C72.7755 4.21871 72.5671 3.98184 72.276 3.81646C71.9849 3.65107 71.6538 3.56838 71.2828 3.56838C70.8318 3.56838 70.4422 3.6819 70.114 3.90896C69.7858 4.13602 69.6217 4.43175 69.6217 4.79616C69.6217 5.11573 69.7416 5.36941 69.9813 5.55723C70.2211 5.74504 70.4751 5.87258 70.7434 5.93986L71.591 6.14169C71.9735 6.23699 72.1647 6.4192 72.1647 6.6883C72.1647 6.8621 72.0862 7.00226 71.9292 7.10878C71.7722 7.2153 71.571 7.26856 71.3256 7.26856C70.789 7.26856 70.4094 7.01067 70.1868 6.49489L69.4847 6.78081C69.6274 7.11719 69.8514 7.3975 70.1568 7.62176Z"
            fill="#5A668A"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.3867 1.42588C14.649 1.42588 13.1929 2.88471 13.1929 4.68496C13.1929 6.47902 14.649 7.93784 16.3867 7.93784C17.3214 7.93784 18.0285 7.62125 18.5858 7.0253C19.155 6.44177 19.3288 5.61613 19.3288 4.94569C19.3288 4.73463 19.3108 4.54839 19.2809 4.38699H16.3867V5.27471H18.442C18.382 5.77133 18.2203 6.13759 17.9746 6.39211C17.675 6.7025 17.2076 7.04392 16.3867 7.04392C15.1223 7.04392 14.1336 5.9886 14.1336 4.67876C14.1336 3.36892 15.1223 2.31359 16.3867 2.31359C17.0698 2.31359 17.5671 2.59294 17.9326 2.95299L18.5438 2.32601C18.0285 1.81697 17.3454 1.42588 16.3867 1.42588ZM23.6671 5.88307C23.6671 4.66634 22.7563 3.78484 21.6358 3.78484C20.5152 3.78484 19.6044 4.66634 19.6044 5.88307C19.6044 7.09359 20.5152 7.9813 21.6358 7.9813C22.7563 7.9813 23.6671 7.09359 23.6671 5.88307ZM21.6358 7.14946C22.247 7.14946 22.7803 6.628 22.7803 5.87686C22.7803 5.11951 22.247 4.60426 21.6358 4.60426C21.0186 4.60426 20.4913 5.11951 20.4913 5.87686C20.4913 6.628 21.0246 7.14946 21.6358 7.14946ZM28.1012 5.88307C28.1012 4.66634 27.1904 3.78484 26.0699 3.78484C24.9494 3.78484 24.0386 4.66634 24.0386 5.88307C24.0386 7.09359 24.9494 7.9813 26.0699 7.9813C27.1904 7.9813 28.1012 7.09359 28.1012 5.88307ZM26.0699 7.14946C26.6811 7.14946 27.2144 6.628 27.2144 5.87686C27.2144 5.11951 26.6871 4.60426 26.0699 4.60426C25.4527 4.60426 24.9254 5.11951 24.9254 5.87686C24.9254 6.628 25.4587 7.14946 26.0699 7.14946ZM32.3616 3.85312H31.5108V4.19455H31.4808C31.2831 3.94624 30.8996 3.72276 30.4142 3.72276C29.4015 3.72276 28.4728 4.64151 28.4728 5.8272C28.4728 7.00047 29.4015 7.91922 30.4142 7.91922C30.8996 7.91922 31.2831 7.69574 31.4808 7.44122H31.5108V7.7454C31.5108 8.54621 31.0973 8.97455 30.4322 8.97455C29.8869 8.97455 29.5513 8.57104 29.4135 8.22961L28.6405 8.56483C28.8622 9.12353 29.4555 9.80639 30.4382 9.80639C31.4808 9.80639 32.3616 9.17319 32.3616 7.62125V3.85312ZM30.4921 7.09359C31.0973 7.09359 31.5767 6.56592 31.5707 5.8272C31.5707 5.08847 31.0973 4.54839 30.4921 4.54839C29.8809 4.54839 29.3656 5.08847 29.3656 5.8272C29.3656 6.55972 29.8809 7.09359 30.4921 7.09359ZM32.9668 1.67419V7.83852H33.8537V1.67419H32.9668ZM36.2925 7.14946C36.7479 7.14946 37.0595 6.91977 37.2931 6.57213L37.9822 7.05013C37.7545 7.39156 37.2212 7.9813 36.2925 7.9813C35.142 7.9813 34.2851 7.05634 34.2851 5.88307C34.2851 4.6353 35.154 3.78484 36.1966 3.78484C37.2452 3.78484 37.7605 4.64772 37.9283 5.11951L38.0182 5.35541L35.3098 6.51626C35.5195 6.93219 35.8371 7.14946 36.2925 7.14946ZM35.1659 5.81478C35.142 5.00777 35.7712 4.59185 36.2266 4.59185C36.5801 4.59185 36.8797 4.77188 36.9756 5.03881L35.1659 5.81478Z"
            fill="#5A668A"
          />
        </svg>
      </StyledIconGoogleMobile>
    );
  }
}
